import type { ConfigPublicEnv } from './index';

declare global {
    interface Window {
        __REALICO_CONFIG__: ConfigPublicEnv;
    }
}

export function clientConfig<K extends keyof ConfigPublicEnv>(key: K): ConfigPublicEnv[K] {
    if (typeof window === 'undefined') {
        throw new Error(
            `clientConfig('${key}') called server-side. Use config.get() from '@/@core/config' instead.`,
        );
    }
    console.log('config ', window.__REALICO_CONFIG__);
    return window.__REALICO_CONFIG__[key] ?? null;
}
